//  RF
if (window.location.pathname.includes("/pages/")) {
  setTimeout(() => {
    $(
      '#RegisterForm input:not([type="checkbox"]):not([type="file"]):not(.country-field):not([type="hidden"]):not([type="submit"])'
    ).each((_, input) => {
      let label = $(input).parent().find("label");
      if (label.length == 0) label = $(input).parent().parent().find("label");
      $(input).attr("placeholder", $(label).text());
    });
  }, 200);
}

// TD on table
document.addEventListener("bss_b2b_doneCheckCp", function (t) {
  $(".bss-b2b-tax-price")?.text(
    BSS_B2B.formatMoney(
      product_unit.variants[0].unit_price * (1 / (1 + BSS_B2B.countryTax))
    ) +
      " " +
      BSS_B2B.taxDisplayTranslations.excluded_vat_text
  );
});

// change quantity
let timeBack = 10;
const handleF = () => {
  const elements = document.querySelectorAll("span.quantity.form");
  const target = elements.length > 0 ? elements[0] : {};
  if (target.length > 0) {
    $(target).on("click", () => {
      setTimeout(() => {
        BSS_B2B.cart.fixer(
          JSON.parse($("#bss-b2b-store-data").html()),
          false,
          false
        );
      }, 500);
    });
  } else if (timeBack-- > 0) {
    setTimeout(handleF, 300);
  }
};
handleF();
